import { UntypedFormGroup } from "@angular/forms";

export const addressValidator = (form: UntypedFormGroup) => {
	if (!form.value) {
		return { incompleteAddress: true };
	}
	const address = form.value.address;

	// TODO: The final country/countryCode check needs to be replaced by a countryCode check be removed (https://dev.azure.com/corilusnv/intocare/_workitems/edit/262152)
	if (
		address
		&& address.street
		&& address.number
		&& address.zip
		&& address.city
		&& (address.countryCode || address.country)
	) {
		return null;
	}
	return { incompleteAddress: true };
};
